<template>
  <div class="wap-page">
    <van-tabs v-model="active" sticky animated>
      <van-tab :title="item.name" v-for="(item,index) in tabs" :key="index" :name="item.key">
        <div v-if="item.key == 0">
        <AssetItem
          v-for="(item, index) in assets"
          :key="index"
          :typeName="item.name"
          :isopen="isopen"
          :useNum="item.money"
        />
      </div>
      <div v-else>
        <AssetInfo
          :title="getTypeName(item.key)"
          :isopen="isopen"
          :num="parseFloat(item.money).toFixed(8)"
          :nums="parseFloat(item.money).toFixed(2)"
          @child-event="changeOpen"
        />
        <div style="margin-top: 5px;overflow-y: auto;height: calc(100vh - 235px);">
        <AssetItem v-for="(subitem, subindex) in item.data" :key="subindex"
          :typeName="subitem.coinName"
          :typeId="item.key"
          :isopen="isopen"
          :useNum="parseFloat(subitem.balance).toFixed(8)"
          :freezeNum="parseFloat(subitem.dbalance).toFixed(8)"
          :conversion="parseFloat(subitem.all_zhprice).toFixed(2)"
          :link="subitem.coinId"
        />
      </div>
      </div>
      </van-tab>
     
    </van-tabs>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer/index.vue";
import { AssetItem, AssetInfo } from "./components/index";
export default {
  name: "AssetsView",
  components: { Footer, AssetItem, AssetInfo },
  data() {
    return {
      active: null,
      isopen: true,
      accountData: {},
      tabs:[],
      assets: [],
    };
  },
  mounted() {
    this.getUserBalanceList();
  },
  methods: {
    changeOpen() {
      this.isopen = !this.isopen;
    },
    async getUserBalanceList() {
      await this.$http({
        method: "post",
        url: "getUserBalanceList",
      }).then((res) => {
        if (res && res.data) this.accountData = res.data;
        this.IntegrationData();
      });
    },
    IntegrationData() {
      this.assets.push({
        name: this.$t("assets.tab11"),
        money: parseFloat(this.accountData.all_price).toFixed(2),
      });
      this.tabs.push({name: this.$t("assets.tab1"),key: 0})
      this.accountData.coinList.forEach((item) => {
        this.tabs.push({name: this.getTabName(item.type),key: item.type,money: parseFloat(item.totalAvailableAsset).toFixed(2),data:item.balanceInfo})
        this.assets.push({
          name: this.getTypeName(item.type),
          money: parseFloat(item.totalAvailableAsset).toFixed(2),
        });
      });
      this.tabs[0].data = this.assets
    },
    getTypeName(val) {
      let result = val;
      switch (val) {
        case 2:
          result = this.$t("assets.tab12");
          break;
        case 1:
          result = this.$t("assets.tab13");
          break;
        case 3:
          result = this.$t("assets.tab14");
          break;
        default:
          break;
      }
      return result;
    },
    getTabName(val){
      let result = val;
      switch (val) {
        case 2:
          result = this.$t("assets.tab2");
          break;
        case 1:
          result = this.$t("assets.tab3");
          break;
        case 3:
          result = this.$t("assets.tab4");
          break;
        default:
          break;
      }
      return result;
    }
  },
};
</script>

<style>
</style>
